WYATT.registerComponent(
  "cart-availability",
  class CartAvailability extends HTMLElement {
    constructor() {
      super();

      this.availabilityData = [];

      this.checkAvailability();
    }

    async checkAvailability() {
      const endpoints = JSON.parse(this.dataset.cartAvailability);
      this.availabilityData = await Promise.all(
        endpoints.map(this.getAvailabilityForItem)
      );

      this.updateAvailabiltyMessages();
    }

    async getAvailabilityForItem(endpoint) {
      const response = await fetch(`${endpoint}&view=location-availability`);

      return response.json();
    }

    updateAvailabiltyMessages() {
      const availabilities = document.querySelectorAll(
        "[data-cart-availability-message]"
      );

      availabilities.forEach((availability) => {
        const locationID =
          availability.dataset.cartAvailabilityMessage ||
          WYATT.selectedStore().shopify_id;
        const isAvailable = this.isAvailableAtLocation(locationID);

        availability
          .querySelector('[data-available="loading"]')
          .classList.add("hidden");
        availability
          .querySelector(`[data-available="${isAvailable}"]`)
          .classList.remove("hidden");
        availability
          .querySelector(`[data-available="${!isAvailable}"]`)
          .classList.add("hidden");
      });
    }

    isAvailableAtLocation(locationID) {
      return this.availabilityData
        .flat()
        .filter(({ id }) => id === locationID)
        .every(({ available }) => available);
    }
  }
);
